import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { removeContainerPadding } from '@components/ions/layouts';

import { maxWidth } from '@utils/helpers';

import { breakpoints, CONTAINER_SIDE_PADDINGS } from '@shared/constants';

export const BannerContainer = styled.div(
    ({ theme: { palette } }) => css`
        background-color: ${palette.tertiary.background};
        padding: 36px 32px 40px;
        width: 100%;

        @media (max-width: ${breakpoints.md}px) {
            padding: 20px 16px 24px 20px;
        }

        @media (max-width: ${breakpoints.sm}px) {
            ${removeContainerPadding('sm')}
        }
    `,
);

export const BannerTitle = styled(Typography.TextH4_20_28)`
    padding-left: 18px;

    ${maxWidth('sm')} {
        padding-left: 0;
    }
`;

export const BannerDescription = styled(Typography.TextBody_14_20)`
    margin-top: 4px;
`;

export const BannerList = styled.ul`
    display: grid;
    margin: 24px 0 0;
    gap: 16px;

    ${maxWidth('sm')} {
        padding-left: ${CONTAINER_SIDE_PADDINGS.sm}px;
    }
`;

export const BannerListItem = styled.li(
    ({ theme: { fontSize } }) => css`
        font-size: ${fontSize['16']}px;
        line-height: ${fontSize['24']}px;
    `,
);

export const BannerLink = styled(Link)(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.tertiary.default};
        font-weight: ${fontWeight.bold};
        text-decoration: none;

        &:hover {
            color: ${palette.tertiary.hover};
        }
    `,
);

export const BannerAnchor = styled.a(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.tertiary.default};
        font-weight: ${fontWeight.bold};
        text-decoration: none;

        &:hover {
            color: ${palette.tertiary.hover};
        }
    `,
);
